"use strict";

exports.__esModule = true;
exports["default"] = void 0;
/**
 * Get run font
 *
 * @param  {Object}  run
 * @return {Object} font
 */

var getFont = function getFont(run) {
  var _run$attributes;

  return ((_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : _run$attributes.font) || null;
};

var _default = getFont;
exports["default"] = _default;